import { msgTypeLU, tagLU } from './utilsfixlu'
import * as _ from 'underscore'

//Globals
//var commonTags = ["8","9","35","49","56","34","52","10"];//'header' tags
var clordidMsgLU = {};//clientOrderID:index
var clordid2orig = {};//clientOrderID:originalClientOrderID
var orig2clordid = {};//originalClientOrderID:clientOrderID
var refno = {};//msgSeqNum:i
var relatedEvents = {};//cliendOrderID:[indexes (ints) which are related]

function spanIt(item,klass){
    //TODO Mixing view with model!
    //return ["<span class='",klass,"'>",item,,'</span>'].join('');
    return item;
}

export function decorateFIX(fixs){
    var fixout = new Array(fixs.length);

    //Iterate through every event
    for(var i=0; i<fixs.length;i++){
        var parsed = fixs[i];
        var fixdict = parsed['lookup'];
        var fixpairs = parsed['pairs'];

        //Decorate msg type
        var msgTypeTag = fixdict[35];
        var msgSeqNum = fixdict[34];
        var msgType = msgTypeLU[msgTypeTag];
        fixdict['msgType'] = msgType? msgType.msgname : msgTypeTag;
        fixdict['msgCat'] = msgType? msgType.msgcat : '';

        var clorderID = fixdict['11'];
        //var refSeqNumber = fixdict['45']

        //store msg in LU
        if (!clordidMsgLU[clorderID]){
            clordidMsgLU[clorderID] = i;
        }

        //store clordid and origclordid heirarchy
        var origclid = fixdict['41'];
        if (origclid) {
            clordid2orig[clorderID] = origclid;
            orig2clordid[origclid] = clorderID;
        }

        //Populate related events
        if (clorderID) {
            if (_.has(relatedEvents,clorderID)) { relatedEvents[clorderID].push(i); }
            else{ relatedEvents[clorderID] = [i]; }
        }
        if (origclid) {
            if (_.has(relatedEvents,origclid)) { relatedEvents[origclid].push(i); }
            else{ relatedEvents[origclid] = [i]; }//this 'else' should not be needed
        }
        //Should completed order chain be considered 'related?' Not unless heavily requested

        //get related refno in relatedEvents

        //store msgseqnum in refno data structure
        refno[msgSeqNum] = i;
        //TODO: when a session reject is found, change font of refseqnum to red


        //Decorate msg detail
        fixdict['msgDetail'] = {};

        var side = ""
        var qty = ""
        var symbol = ""
        var price = ""
        var origFIX = ""
        var detail = ""

        //=======Handle specific event types========
        //New Order Single
        if (msgTypeTag === 'D') {
            //order id, side, qty, symbol, price
            //var id = fixdict['11'];
            side = tagLU['54'].enum[fixdict['54']]
            qty = fixdict['38'];
            symbol = fixdict['55'];
            price = fixdict['44'];

            detail =  {side:side,qty:qty,symbol:symbol};
            if (price) {
                detail.price = price;
            }
            fixdict['msgDetail'] = detail;
        }

        //Execution Report
        if (msgTypeTag === '8') {
            var execTypeTag = fixdict['150'];//TODO FIX.4.0 had execTransType(20), integrate that?
            var execType = tagLU['150'].enum[execTypeTag];

            var leaves = fixdict['151'];
            var cumQty = fixdict['14'];


            //get attributes: side, qty, symbol, filled, leaves
            origFIX = fixs[clordidMsgLU[clorderID]];
            var msgDetail = {};

            if (origFIX) {
                side = spanIt(tagLU['54'].enum[origFIX['54']] || '','side');
                qty = spanIt(origFIX['38'] || "",'qty');
                symbol = spanIt(origFIX['55'] || "",'symbol');
                price = spanIt(origFIX['44'] || "",'price');

                msgDetail = {side:side,qty:qty,symbol:symbol,price:price,cumQty:cumQty,leaves:leaves};

                //Percentage complete
                var _qty = parseFloat(qty);
                var _cumQty = parseFloat(cumQty);

                if (_qty && _cumQty) {
                    msgDetail.percentComplete = (_cumQty/_qty) * 100;
                }
            }

            fixdict['msgType'] = ['ER', execType].join(' ');
            fixdict['msgDetail'] = msgDetail;
        }

        //Order Reject (session)
        if (msgTypeTag === '3') {
            var rejectReason = fixdict['58'] || '';
            //iterate and find refseqnum
            fixdict['msgDetail'] = {text:rejectReason};
            //TODO:relatedEvents
            //get clordid of rejected msg
            //add this event to list of related events for that clordid
            var refSeqNum = fixdict['45'];
            var clidOfRejMsg = fixs[refno[refSeqNum]];
            if (clidOfRejMsg && clidOfRejMsg['11']) {
                if (_.has(relatedEvents,clidOfRejMsg['11'])) { relatedEvents[clidOfRejMsg['11']].push(i); }
                else{ relatedEvents[clidOfRejMsg['11']] = [i]; }
            }
        }

        //Order Cancel Request
        if (msgTypeTag === 'F') {
            origFIX = clordidMsgLU[clorderID];
            side = tagLU['54'].enum[fixdict['54']];
            qty = fixdict['38'];
            symbol = fixdict['55'];
            price = origFIX['44'];

            detail =  {side:side,qty:qty,symbol:symbol};
            if (price) {
                detail.price = price;
            }
            fixdict['msgDetail'] = detail;
        }

        //Order Cancel/Replace Request
        if (msgTypeTag === 'G') {
            side = tagLU['54'].enum[fixdict['54']];
            qty = fixdict['38'];
            symbol = fixdict['55'];
            price = fixdict['44'];

            detail =  {side:side,qty:qty,symbol:symbol};
            if (price) {
                detail.price = price;
            }
            fixdict['msgDetail'] = detail;
        }
        //======Done handling specific order types======

        fixout[i] = {lookup:fixdict, pairs:fixpairs};
        //fixdict['pairs'] = fixpairs;
        //fixout[i] = fixdict;
    }



    return fixout;
}


// function label(item, type, data){
//   //TODO: clean up logic and organize better (including parameters, etc.)
//     //All pending ERs should be yellow
//     //NOS green
//     //Session reject and ER reject red
//     //cancel request red (?)
//     //Amend green
//     //ER confirm default
//     //ER Fills info

//   if (!item) {
//     return '';
//   }
//   if (type === 'side') {
//     return item === 'BUY' ? 'label label-success' : 'label label-info';
//   }
//   else if (type === 'tagType') {
//     if(item === '35' || item === '150') return 'label label-default';
//     return !_.contains(commonTags, item)? 'label label-info' : 'label label-gray';
//   }
//   else if (type === 'msgCat') {

//     //OrderCancelRequest
//     if (data['35'] === 'F') { return 'label label-default';}

//     //Reject
//     else if (data['35'] === '3') {return 'label label-danger';}

//     //NewOrderSingle
//     else if (data['35'] === 'D') {return 'label label-success';}

//     //ER Fill/Partial/Trade TODO: Handle 'trade' ERs
//     else if (data['35'] === '8' && (data['150'] === '2' || data['150'] === '1' || data['150'] === 'F')) {return 'label label-info';}

//     //ER Pending ...
//     else if (data['35'] === '8' && (data['150'] === '6' || data['150'] === 'A' || data['150'] === 'E')) {return 'label label-warning';}

//     //General admin messages
//     else if (item === 'admin') { return 'label label-gray';}
//   }
//   return 'label label-gray';
// }

// function getDescs(tag, value){
//     var tagLURslt = tagLU[tag];

//     //Lookup tag description
//     var tagDesc = tagLURslt ? tagLURslt.desc : "";

//     //Lookup value description
//     var valDesc = tagLURslt ? tagLURslt.enum[value] || "" : "";

//     return {tagDesc:tagDesc, valDesc:valDesc};
// }

//http://www.mredkj.com/javascript/numberFormat.html
// function addCommas(nStr)
// {
// 	nStr += '';
// 	var x = nStr.split('.');
// 	var x1 = x[0];
// 	var x2 = x.length > 1 ? '.' + x[1] : '';
// 	var rgx = /(\d+)(\d{3})/;
// 	while (rgx.test(x1)) {
// 		x1 = x1.replace(rgx, '$1' + ',' + '$2');
// 	}
// 	return x1 + x2;
// }
